import React from 'react';
import { UserContextEntity } from './entities/UserEntity';
import { AlertEntity } from './layouts/Alert/AlertEntity';
const AppContext = React.createContext<{
    stateShowLoading: boolean,
    contextAccessToken: string,
    contextUserEntity: UserContextEntity | null,
    contextShowAlertFunc: (val: AlertEntity) => void,
    contextShowLoadingFunc: (val: boolean) => void,
    contextMakeHeaderFunc: (val: string) => void,
}>({
    stateShowLoading: false,
    contextAccessToken: '',
    contextUserEntity: null,
    contextShowAlertFunc: (val: AlertEntity) => void {},
    contextShowLoadingFunc: (val: boolean) => void {},
    contextMakeHeaderFunc: (val: string) => void {},
});
export default AppContext;